import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_OLO_DEACTIVATION_PHYSIC } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolDeactivationPhysicState extends EntityState<IID_OLO_DEACTIVATION_PHYSIC, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OLO_DEACTIVATION_PHYSIC , realtimeEntity: 'IID_OLO_DeactivationPhysic'})
@InterfaceDataStore(InterfaceName.OLO_DEACTIVATION_PHYSIC)
export class IIDolDeactivationPhysicStore extends EntityStore<IIDolDeactivationPhysicState> {
  constructor() {
    super([]);
  }
}
